import {useTranslation} from "../../../../__snowpack__/link/packages/i18n/dist/i18n.esm.js";
import MaterialTypography from "../../../../__snowpack__/pkg/@mui/material/Typography.js";
import React from "react";
import DataLabel from "../data-label/data-label.component.js";
import {UnitContainer} from "./unit.styles.js";
import {makeStyles} from "../../../../__snowpack__/pkg/@mui/styles.js";
const useStyles = makeStyles({
  word_break: {
    wordBreak: "break-all"
  }
});
function MergeUnit({
  mergeUnit
}) {
  const {
    t
  } = useTranslation();
  const classes = useStyles();
  return /* @__PURE__ */ React.createElement(UnitContainer, {
    key: mergeUnit.id
  }, /* @__PURE__ */ React.createElement(MaterialTypography, {
    className: classes.word_break
  }, mergeUnit.number), /* @__PURE__ */ React.createElement(DataLabel, {
    label: t("units.type"),
    content: mergeUnit.unit_type.name
  }), /* @__PURE__ */ React.createElement(DataLabel, {
    label: t("units.area"),
    content: mergeUnit.sq_feet
  }), /* @__PURE__ */ React.createElement(DataLabel, {
    label: t("units.building"),
    content: mergeUnit.building
  }));
}
export default /* @__PURE__ */ React.memo(MergeUnit);
